import axios from 'axios'
import {Message} from 'iview'
import store from '../store'
import router from '../router'
import vm from '../main.js'

const ceshiURL = "/ceshi";//测试地址
axios.defaults.baseURL = "/gyl"; //"http://172.16.12.125:8769";//
axios.defaults.timeout = 600000;
const defaults_headers = {
    'X-Requested-With': 'XMLHttpRequest',
	'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
}
const defaults_headers2 = {
    'X-Requested-With': 'XMLHttpRequest',
	'Content-Type': 'application/json; charset=UTF-8'
}
const defaults_headers3 = {
    'X-Requested-With': 'XMLHttpRequest',
	'Content-Type': 'text/plain; charset=UTF-8'
}
axios.interceptors.request.use(config => {
	// loading
	return config
}, error => {
	return Promise.reject(error)
})

axios.interceptors.response.use(response => {
	return response
}, error => {
	console.log(error.config)
	if(error.response.data.status==10012){
		// //通过refreshToken调用接口刷新token，然后刷新token，等待后端接口
		// const newToken = 'wait';
		// error.config.headers.Authorization = 'bearer '+newToken;
		// store.commit("setAccess",newToken);
		// return axios.request(error.config);

		// 线上遇到token失效后闪退，再登录时提示已登录的bug，在此补救，如异常闪退则调用签退接口退出登录
		// const userId = store.state.user.user.choperaphone;
		// const choperatorcode = store.state.user.user.choperatorcode;
		// var org = JSON.parse(localStorage.getItem('org'));
		// vm.$ajax.get('/auth/logouting',{chorgcode:org}).then(data => {
		// 	if(data.status==vm.$ajax.HTTP_S){
		// 		vm.$store.commit('isLogin',false);
		// 		vm.$store.commit('setUserId',userId);
		// 		vm.$store.commit('setChoperatorcode',choperatorcode);
		// 		if(store.state.user.user.is_plat=='1'){
		// 			location.href="/plat-login";
		// 		}else{
		// 			location.href="/login";
		// 			// vm.closeSocket();//签退时关闭websocket连接
		// 		}
		// 	}else{
		// 		console.log(data)
		// 	}
		// });
		// 线上遇到token失效后闪退，再登录时提示已登录的bug，在此补救，如异常闪退则调用签退接口退出登录
	}
	if (error && error.response) {
		return error.response;
	}
	return Promise.resolve(error)
})

//先执行
function checkStatus(response) {
	// loading
	// 如果http状态码正常，则直接返回数据
	if (response && (response.status === 200 || response.status === 304)) {
		return response.data	// 如果不需要除了data之外的数据，可以直接 return response.data
	}else if(response.status == 400){
		Message.error({content:response.data.message,closable: true});
		return response
	}else if(response.status == 401){
		Message.error({content:response.data.message,closable: true});
		var token = JSON.parse(localStorage.getItem('access_token'));
		if(response.data.status==10013){//调转到登录页
			var token = JSON.parse(localStorage.getItem('access_token'));
			// 线上遇到token失效后闪退，再登录时提示已登录的bug，在此补救，如异常闪退则调用签退接口退出登录
			// const userId = store.state.user.user.choperaphone;
			// const choperatorcode = store.state.user.user.choperatorcode;
            // var org = JSON.parse(localStorage.getItem('org'));
			// vm.$ajax.get('/auth/logouting',{chorgcode:org}).then(data => {
			// 	if(data.status==vm.$ajax.HTTP_S){
			// 		vm.$store.commit('isLogin',false);
			// 		vm.$store.commit('setUserId',userId);
			// 		vm.$store.commit('setChoperatorcode',choperatorcode);
			// 		if(store.state.user.user.is_plat=='1'){
			// 			location.href="/plat-login";
			// 		}else{
			// 			location.href="/login";
			// 			// vm.closeSocket();//签退时关闭websocket连接
			// 		}
			// 	}else{
			// 		console.log(data)
			// 	}
			// });
			// 线上遇到token失效后闪退，再登录时提示已登录的bug，在此补救，如异常闪退则调用签退接口退出登录
			store.commit('isLogin',false)
			// location.href="/login";
            location.href="/login";
		}
		return response
	}else if(response.status == 500){
		//调整到登录页
		Message.error({content:response.data.message,closable: true});
		return response
	}
	// 异常状态下，把错误信息返回去
	return {
		status: -404,
		msg: '网络异常'
	}
}
//后执行
function checkCode(res) {
	// 如果code异常(这里已经包括网络错误，服务器错误，后端抛出的错误)，可以弹出一个错误提示，告诉用户
	if (res.status === -404) {
		Message.error({content:res.msg,closable: true});
	}
	return res
}


export default {
	login(url, params){
		return axios({
			method: 'post',
			url,
			params
		}).then((response) => {
			return checkStatus(response)
		}).then((res) => {
			return checkCode(res)
		})
	},
	login1(url, data){//application/json
		return axios({
			method: 'post',
			url,
			data:data,
			headers:defaults_headers2
		}).then((response) => {
			return checkStatus(response)
		}).then((res) => {
			return checkCode(res)
		})
	},
	login2(url, data){//text/plain
		return axios({
			method: 'post',
			url,
			data:data,
			headers:defaults_headers3
		}).then((response) => {
			return checkStatus(response)
		}).then((res) => {
			return checkCode(res)
		})
	},
	post(url, data) {
		return axios({
			method: 'post',
			url,
			params:data,
			headers:this.getHeader()
		}).then((response) => {
			return checkStatus(response)
		}).then((res) => {
			return checkCode(res)
		})
	},
	postJson(url,data) {//application/json
		return axios({
			method: 'post',
			url,
			data:data,
			headers:this.getHeader2()
		}).then((response) => {
			return checkStatus(response)
		}).then((res) => {
			return checkCode(res)
		})
	},
    postJsonData(url,data) {//application/json 返回取 res
		return axios({
			method: 'post',
			url,
			data:data,
			headers:this.getHeader2(),
			responseType:'blob',
		}).then((response) => {
			return response
		}).then((res) => {
			return checkCode(res)
		})
	},
	postText(url,data) {//text/plain
		return axios({
			method: 'post',
			url,
			data:data,
			headers:this.getHeader3()
		}).then((response) => {
			return checkStatus(response)
		}).then((res) => {
			return checkCode(res)
		})
	},
	get(url, params) {
		return axios({
			method: 'get',
			url,
			params,
			headers:this.getHeader()
		}).then((response) => {
			return checkStatus(response)
		}).then((res) => {
			return checkCode(res)
		})
	},
	preview(url, params) {//预览
		return axios({
			method: 'get',
			url,
			params,
			responseType:'blob',
			headers:this.getHeader()
		}).then((response) => {
			return response
		}).then((res) => {
			return checkCode(res)
		})
	},
	previewPost(url, params) {//预览
		return axios({
			method: 'post',
			url,
			params,
			responseType:'blob',
			headers:this.getHeader()
		}).then((response) => {
			return response
		}).then((res) => {
			return checkCode(res)
		})
	},
	download(url, params) {//下载
		return axios({
			method: 'post',
			url,
			params,
			responseType:'blob',
			headers:this.getHeader()
		}).then((response) => {
			return checkStatus(response)
		}).then((res) => {
			return checkCode(res)
		})
	},
	downloadGet(url, params) {//下载
		return axios({
			method: 'get',
			url,
			params,
			responseType:'blob',
			headers:this.getHeader()
		}).then((response) => {
			return checkStatus(response)
		}).then((res) => {
			return checkCode(res)
		})
	},
	ceshi(url, params) {
		return axios({
			baseURL:ceshiURL,
			method: 'post',
			url,
			params,
			headers:this.getHeader()
		}).then((response) => {
			return checkStatus(response)
		}).then((res) => {
			return checkCode(res)
		})
	},
	ceshiPreview(url, params) {//预览
		return axios({
			baseURL:ceshiURL,
			method: 'get',
			url,
			params,
			responseType:'blob',
			headers:this.getHeader()
		}).then((response) => {
			return response
		}).then((res) => {
			return checkCode(res)
		})
	},
	ceshiDownload(url, params) {//下载
		return axios({
			baseURL:ceshiURL,
			method: 'post',
			url,
			params,
			responseType:'blob',
			headers:this.getHeader()
		}).then((response) => {
			return checkStatus(response)
		}).then((res) => {
			return checkCode(res)
		})
	},
	ceshi0(url, params){
		return axios({
			baseURL:ceshiURL,
			method: 'post',
			url,
			params
		}).then((response) => {
			return checkStatus(response)
		}).then((res) => {
			return checkCode(res)
		})
	},
	ceshi1(url, data){//application/json
		return axios({
			baseURL:ceshiURL,
			method: 'post',
			url,
			data:data,
			headers:defaults_headers2
		}).then((response) => {
			return checkStatus(response)
		}).then((res) => {
			return checkCode(res)
		})
	},
	ceshi2(url, data) {//json格式
		return axios({
			baseURL:ceshiURL,
			method: 'post',
			url,
			data:data,
			headers:this.getHeader2()
		}).then((response) => {
			return checkStatus(response)
		}).then((res) => {
			return checkCode(res)
		})
	},
	ceshi3(url, data) {//上传
		return axios({
			baseURL:ceshiURL,
			method: 'post',
			url,
			data:data,
			headers:this.getHeader3()
		}).then((response) => {
			return checkStatus(response)
		}).then((res) => {
			return checkCode(res)
		})
	},
	ceshiGet(url, params) {
		return axios({
			baseURL:ceshiURL,
			method: 'get',
			url,
			params,
			headers:this.getHeader()
		}).then((response) => {
			return checkStatus(response)
		}).then((res) => {
			return checkCode(res)
		})
	},
	getHeader(){
		var user = store.state.user;
		var access_token_header =  {'Authorization':'bearer '+user.access_token};
		return Object.assign({}, defaults_headers,access_token_header);//合并header
	},
	getHeader2(){
		var user = store.state.user;
		var access_token_header =  {'Authorization':'bearer '+user.access_token};
		return Object.assign({}, defaults_headers2,access_token_header);//合并header
	},
	getHeader3(){
		var user = store.state.user;
		var access_token_header =  {'Authorization':'bearer '+user.access_token};
		return Object.assign({}, defaults_headers3,access_token_header);//合并header
	},
	HTTP_S:"0",
	HTTP_F:"1"
}



// WEBPACK FOOTER //
// ./src/libs/http.js